const ITEMS = [
  "90% Homes with 3-Side Open Views",
  "IGBC Platinum Precertified",
  "3-Acre Central Park",
  "Double-Height Sky Terraces",
  "Vastu-Compliant Layouts",
  "Hatishala · Off Action Area III",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#EAF5D6] border-y border-[#84CC16]/25 py-4 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center text-[#84CC16] font-mono-spec text-[11px] tracking-[0.3em] uppercase px-6">
            {item}
            <span className="ml-12 text-[#3F6212]/30">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
